import { Slider, withStyles } from "@material-ui/core";
import React, { Component } from "react";

const TempSlider = withStyles({
  root: {
    color: '#0b943f',
    margin: "0",
    padding: "16px 0",
    width: 200,
  },
  rail: {
    height: "4px",
    backgroundColor: '#C8CED8',
    borderRadius: "2px"
  },
  thumb: {
    height: 15,
    width: 15,
    marginTop: -5.5,
    backgroundColor: '#0b943f',
    position: 'relative',
    borderRadius: '50%',
    "&::after": {
      content: '""',
      position: 'absolute',
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 7,
      height: 7,
      backgroundColor: '#ffffff',
      borderRadius: '50%',
    }
  },
  track: {
    height: "4px",
    borderRadius: 4,
  }
})(Slider);


export default TempSlider;